import ConsultationBanner from "@/components/consultation-banner";
import PlacementStartWarmup from "../placement-start-warmup";
import PlacementHeader, { PlacementLoadingIndicator } from "./placement-header";
import PlacementOverallScore from "./placement-overall-score";
import PlacementTestDetails from "./placement-test-details";
import PlacementProviderBreakdown from "./placement-provider-breakdown";
import { Recommendations } from "../recommendations";

const InboxPlacementReport = () => {
  return (
    <div className="w-full space-y-4" id="placement-test-print">
      <PlacementLoadingIndicator />
      <PlacementHeader />

      <PlacementOverallScore />

      <PlacementStartWarmup />

      <ConsultationBanner type="inbox-placement" />

      <PlacementTestDetails />

      <PlacementProviderBreakdown />

      <Recommendations />
    </div>
  );
};

export default InboxPlacementReport;
